import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#243b5a] text-white" data-testid="footer">
      <div className="container-max px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand with Logo */}
          <div>
            <div className="mb-6">
              <img 
                src="/awaken-logo.png" 
                alt="Awaken India Tours - Unforgettable First India Trip" 
                className="w-48 h-auto"
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Small group luxury journeys to India for curious, comfort-seeking travelers experiencing the subcontinent for the first time.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4AF37] transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D4AF37] transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#D4AF37]">Explore</h4>
            <ul className="space-y-3">
              {[
                { name: "The Journey", path: "/journey" },
                { name: "Day by Day Itinerary", path: "/itinerary" },
                { name: "Pricing & Dates", path: "/pricing" },
                { name: "About Your Host", path: "/about" },
                { name: "Testimonials", path: "/testimonials" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#D4AF37]">Resources</h4>
            <ul className="space-y-3">
              {[
                { name: "How It Works", path: "/how-it-works" },
                { name: "FAQs", path: "/faqs" },
                { name: "Travel Prep", path: "/travel-prep" },
                { name: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/70 hover:text-[#D4AF37] transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg mb-6 text-[#D4AF37]">Get in Touch</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:781-367-4010" className="flex items-center gap-3 text-white/70 hover:text-[#D4AF37] transition-colors">
                  <Phone size={18} />
                  <span>781-367-4010</span>
                </a>
              </li>
              <li>
                <a href="mailto:aaron@awakenindiatours.com" className="flex items-center gap-3 text-white/70 hover:text-[#D4AF37] transition-colors">
                  <Mail size={18} />
                  <span>aaron@awakenindiatours.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-white/70">
                  <MapPin size={18} className="mt-1 flex-shrink-0" />
                  <span>Serving travelers from New York, New Jersey & the East Coast</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} Awaken India Tours. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-white/50 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms-of-service" className="text-white/50 hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
